import type { FaireProductEntity } from "../../entity_types/product";

export const p_a53jeckt8f: FaireProductEntity = {
  token: "p_a53jeckt8f",
  type: "product",
  name: "potted tree mini enclosure notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/c2fb72a2dd223f40ae72ce781342c8ebe7ea629c6d71e348657d88f662c2b1a4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/072b997783aa3a99e27a5c65cf51b40fd480841db0524ab5a9699299308fd952.jpeg",
  ],
  priceDollars: 2,
  description:
    'A mini notecard for petite greetings. Perfect for adding to a gift or popping in a gift card for a pretty (and easy!) presentation.\n\n𝐃𝐞𝐭𝐚𝐢𝐥𝐬:\n\n• single card + envelope\n• blank inside\n• 2.5" x 3.5"\n• Printed on 120lb superfine paper\n• Original watercolor artwork by Emily Lex',
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:47.530Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
